webpackJsonp([158438950570844],{

/***/ 409:
/***/ (function(module, exports) {

	module.exports = {
		"data": {
			"postBySlug": {
				"html": "<p><font color=\"green\"><H1>Operating model: operating rhythm</h1></font></p>\n<h3 id=\"to-ensure-interactions-with-dmgt-are-productive-and-predictable-an-operating-rhythm-of-informal-catch-ups-and-more-formal-updates-has-been-developed-the-rhythm-is-designed-to-give-operating-company-ceos-and-cfos-more-visibility-of-dmgt-processes-and-guidance-to-when-proposals-should-be-submitted\"><a href=\"#to-ensure-interactions-with-dmgt-are-productive-and-predictable-an-operating-rhythm-of-informal-catch-ups-and-more-formal-updates-has-been-developed-the-rhythm-is-designed-to-give-operating-company-ceos-and-cfos-more-visibility-of-dmgt-processes-and-guidance-to-when-proposals-should-be-submitted\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>To ensure interactions with DMGT are productive and predictable, an operating rhythm of informal catch ups and more formal updates has been developed. The rhythm is designed to give Operating Company CEOs and CFOs more visibility of DMGT processes and guidance to when proposals should be submitted.</h3>\n<p><font color=\"green\"><H2>CEO 1:1 catch ups</h2></font></p>\n<h4 id=\"dmgt-board-and-committees\"><a href=\"#dmgt-board-and-committees\" aria-hidden=\"true\" class=\"anchor\"><svg aria-hidden=\"true\" height=\"16\" version=\"1.1\" viewBox=\"0 0 16 16\" width=\"16\"><path fill-rule=\"evenodd\" d=\"M4 9h1v1H4c-1.5 0-3-1.69-3-3.5S2.55 3 4 3h4c1.45 0 3 1.69 3 3.5 0 1.41-.91 2.72-2 3.25V8.59c.58-.45 1-1.27 1-2.09C10 5.22 8.98 4 8 4H4c-.98 0-2 1.22-2 2.5S3 9 4 9zm9-3h-1v1h1c1 0 2 1.22 2 2.5S13.98 12 13 12H9c-.98 0-2-1.22-2-2.5 0-.83.42-1.64 1-2.09V6.25c-1.09.53-2 1.84-2 3.25C6 11.31 7.55 13 9 13h4c1.45 0 3-1.69 3-3.5S14.5 6 13 6z\"></path></svg></a>DMGT Board and Committees:</h4>\n<ul>\n<li>\n<p>Regular conversations between DMGT CEO and Operating Company CEOs.</p>\n</li>\n<li>\n<p>Based around a set of regular items of discussion, such as objectives and top priorities.</p>\n</li>\n<li>\n<p>Priorities should be clear, measurable, binary actions to be achieved over 3-6 months and the drivers of performance.</p>\n</li>\n</ul>\n<p><font color=\"green\"><H2>Performance updates</h2></font></p>\n<ul>\n<li>\n<p>DMGT CEO, DMGT CFO, Operating Company CEO and Operating Company CFO.</p>\n</li>\n<li>\n<p>Focus on performance over preceding and coming months.</p>\n</li>\n<li>\n<p>Financial focus using monthly dashboards/flash reports.</p>\n</li>\n<li>\n<p>Monthly to quarterly.</p>\n</li>\n</ul>\n<p><font color=\"green\"><H2>CFO 1:1 catch ups</h2></font></p>\n<ul>\n<li>\n<p>Regular schedule of catch ups between DMGT CFO and Operating Company CFOs.</p>\n</li>\n<li>\n<p>Aimed at increasing transparency and understanding operating performance.</p>\n</li>\n</ul>\n<p><font color=\"green\"><H2>Operating Company boards</h2></font></p>\n<ul>\n<li>\n<p>Broader Operating Company update and DMGT leadership team meeting.</p>\n</li>\n<li>\n<p>To be held at the Operating Companies with DMGT CEO and DMGT CFO in attendance.</p>\n</li>\n<li>\n<p>Discussion of ongoing focuses and longer term strategy.</p>\n</li>\n<li>\n<p>DMGT will nominate members of Operating Company Boards in its capacity as ultimate parent company shareholder.</p>\n</li>\n<li>\n<p>Any other recommendations for Operating Company Boards must be discussed with the DMGT CEO in advance.\n• Operating Company Boards must act ethically and in accordance with all applicable laws and Operating Company constitutional documents.</p>\n</li>\n<li>\n<p>Operating Company Boards must act within the authorisation and approval limits of the Green Book.</p>\n</li>\n</ul>\n<hr>\n<p><font color=\"green\"><H2>Contacts: </h2></font></p>\n<p>Paul Zwillenberg, DMGT CEO (<a href=\"mailto:zwillenberg@dmgt.com\">zwillenberg@dmgt.com</a>)\n<br>\nFran Sallas, Company Secretary (<a href=\"mailto:fran.sallas@dmgt.com\">fran.sallas@dmgt.com</a>)\n<br>\nTim Collier, DMGT CFO (<a href=\"mailto:tim.collier@dmgt.com\">tim.collier@dmgt.com</a>)\n<br>\nMatt Oatway, Chief of Staff (<a href=\"mailto:matt.oatway@dmgt.com\">matt.oatway@dmgt.com</a>)</p>\n<hr>\n<p>Go to www.iworkhere.dmgt.com for:\n<a href=\"https://www.iworkhere.dmgt.com/member/login?destination=node/39%253Fpolicy_type%253D63\" title=\"Guidance for Directors\">Guidance for Directors</a></p>",
				"timeToRead": 2,
				"excerpt": "Operating model: operating rhythm To ensure interactions with DMGT are productive and predictable, an operating rhythm of informal catch ups...",
				"frontmatter": {
					"title": "Lesson Six",
					"cover": null,
					"date": null,
					"category": null,
					"tags": null
				}
			},
			"tableOfContents": {
				"chapters": [
					{
						"title": "1. Main Chapter",
						"entries": null,
						"chapters": [
							{
								"title": "1.1 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_one.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/1-dmgt-at-a-glance"
												},
												"frontmatter": {
													"title": "1. DMGT at a glance "
												}
											}
										}
									}
								],
								"chapters": [
									{
										"title": "1.1.1 Sub-subchapter",
										"entries": [
											{
												"entry": {
													"id": "/opt/build/repo/content/lessons/lesson_two.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/lesson-two-scope-and-responsibilities"
														},
														"frontmatter": {
															"title": "Lesson Two - Scope and responsibilities"
														}
													}
												}
											},
											{
												"entry": {
													"id": "/opt/build/repo/content/lessons/lesson_three.md absPath of file",
													"childMarkdownRemark": {
														"fields": {
															"slug": "/lesson-three-code-of-conduct"
														},
														"frontmatter": {
															"title": "Lesson Three - Code of Conduct"
														}
													}
												}
											}
										]
									}
								]
							},
							{
								"title": "1.2 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_four.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/lesson-four"
												},
												"frontmatter": {
													"title": "Lesson Four"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "2. Main Chapter",
						"entries": null,
						"chapters": [
							{
								"title": "2.1 Subchapter",
								"entries": [
									{
										"entry": {
											"id": "/opt/build/repo/content/lessons/lesson_five.md absPath of file",
											"childMarkdownRemark": {
												"fields": {
													"slug": "/lesson-five"
												},
												"frontmatter": {
													"title": "Lesson Five"
												}
											}
										}
									}
								],
								"chapters": null
							}
						]
					},
					{
						"title": "3. Main Chapter",
						"entries": [
							{
								"entry": {
									"id": "/opt/build/repo/content/lessons/lesson_six.md absPath of file",
									"childMarkdownRemark": {
										"fields": {
											"slug": "/lesson-six"
										},
										"frontmatter": {
											"title": "Lesson Six"
										}
									}
								}
							}
						],
						"chapters": null
					}
				]
			}
		},
		"pathContext": {
			"slug": "/lesson-six"
		}
	};

/***/ })

});


// WEBPACK FOOTER //
// path---lesson-six-eb2b83c98a77e5a339e3.js